// projects/search — the fields a project is searched by on the platform's
// projects list, ONE function both faces call (ADR-072 §6 · ADR-045): the
// display name, the mother company and the service provider by their words (a
// mistake forgiven); the project's immutable code (`projects.name`, unique) a
// KEY — typed whole it answers alone, typed in part a code, never forgiven.
export function platformProjectSearchFields(p) {
    return { name: [p.display_name, p.mother_company, p.service_provider].filter(Boolean).join(' '), codes: [p.name], keys: [p.name] };
}
